import React from 'react';

import Row from 'components/Row';

import FieldHelpIcon from 'components/FieldHelpIcon';

import {
  StyledRowWrapper,
  RowContainer,
  StyledDivider,
  RequiredAsterisk,
} from 'components/Entities/EntityDetailsTab/styles';

import { NotAskedNote } from 'containers/PipelinesDetails/components/conditions/styles';

import { FieldNotesContext, WhyShownControl } from './WhyShown';

type EntityRowWrapperProps = {
  rowName: string;
  withDivider: boolean;
  children: React.ReactNode;
  required?: boolean;
  helpText?: string | null;
  fieldKey?: string;
};

const EntityRowWrapper: React.FC<EntityRowWrapperProps> = ({
  rowName,
  withDivider,
  children,
  required,
  helpText,
  fieldKey,
}) => {
  // Keyed by field key, not label.
  const notes = React.useContext(FieldNotesContext);
  const note = fieldKey ? notes[fieldKey] : undefined;

  return (
    <StyledRowWrapper>
      <RowContainer>
        <Row
          name={
            <>
              {rowName}
              {required && <RequiredAsterisk>*</RequiredAsterisk>}
              {helpText && <FieldHelpIcon name={rowName} helpText={helpText} />}
              {note?.why && <WhyShownControl why={note.why} fieldName={rowName} fieldKey={note.fieldKey} />}
            </>
          }
          id={`entities-${rowName.toLowerCase()}-field`}
          valueTestId={fieldKey ? `entity-field-${fieldKey}` : undefined}
        >
          {children}
          {note?.notAsked && (
            <NotAskedNote data-testid={`field-not-asked-${note.fieldKey}`}>Not currently asked</NotAskedNote>
          )}
        </Row>
      </RowContainer>
      {withDivider && <StyledDivider />}
    </StyledRowWrapper>
  );
};

export default EntityRowWrapper;
